import React from 'react'

import ListRecipe from './ListRecipe'
import LoadingIcon from './LoadingIcon'

class Recipes extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      chapterDescriptionOpen: false
    }
  }

  showDescription(e) {
    e.preventDefault()

    const toggleDescription = !this.state.chapterDescriptionOpen

    this.setState((state, props) => ({
      chapterDescriptionOpen: toggleDescription
    }))
  }

  render() {
    let chapterTitle = ''
    let chapterRecipesCount = ''
    let chapterDescription = ''
    let chapterDescriptionSection = ''

    let recipeList = ''
    let recipeItems = ''

    if (this.props.chapter !== undefined) {
      chapterTitle = this.props.chapter.title

      if (
        this.props.chapter.description !== undefined &&
        this.props.chapter.description !== ''
      ) {
        chapterDescription = this.props.chapter.description
      }

      if (
        chapterDescription !== undefined &&
        chapterDescription !== null &&
        chapterDescription !== ''
      ) {
        const chapterDescriptionOpen = this.state.chapterDescriptionOpen
        const HTMLChapterDescription = { __html: chapterDescription }
        const readMoreLink = (
          <a
            href="#"
            className="chapter__description__read-more"
            onClick={e => {
              this.showDescription(e)
            }}
          >
            {chapterDescriptionOpen ? 'Read less' : 'Read more'}
          </a>
        )
        chapterDescriptionSection = (
          <div className="chapter__description">
            <div
              className={
                chapterDescriptionOpen
                  ? 'chapter__description__text open'
                  : 'chapter__description__text'
              }
              dangerouslySetInnerHTML={HTMLChapterDescription}
            />
            {chapterDescription.length > 100 ? readMoreLink : ''}
          </div>
        )
      }

      if (this.props.chapter.recipesCount !== undefined) {
        chapterRecipesCount = '(' + this.props.chapter.recipesCount + ')'
      }
    }

    if (this.props.recipes !== undefined) {
      if (this.props.recipes.length > 0) {
        recipeItems = this.props.recipes.map(item => (
          <ListRecipe
            key={item.uuid}
            chapterUrl={this.props.chapterUrl}
            recipe={item}
          />
        ))
        recipeList = <ul className="recipe-list">{recipeItems}</ul>
      } else {
        recipeList = <div className="warning text-center">No Recipes Found</div>
      }
    } else {
      recipeList = (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
      )
    }

    return (
      <div>
        <h2 className="text-center">
          {chapterTitle} {chapterRecipesCount}
        </h2>
        {chapterDescriptionSection}
        {recipeList}
      </div>
    )
  }
}

export default Recipes



// WEBPACK FOOTER //
// ./src/Components/Recipes.js